import { Component, OnInit, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ImageListResult } from '../../result/image-list-result';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import { ImageHostingService } from '../../common/api/image-hosting.service';
import { ImageModel } from '../../common/model/image.model';

@Component({
    selector : 'app-sign-list',
    templateUrl : './sign-list.component.html',
    styleUrls : ['./sign-list.component.css'],
})
export class SignListComponent implements OnInit {

    posters: ImageModel[];
    row = 20;
    page = 0;
    totalPage: number;
    totalElement: number;
    numberOfElements: number;
    result: ImageListResult = new ImageListResult();
    htmlText = '';
    pageStart: number;
    pageEnd: number;
    sort = 'C.STORED_DATE,DESC';
    convertName = '';
    signUrl = '';
    minWidth = '450px';
    url: string = environment.imageUrl;
    modalSrc = '';
    modalIndex: any;
    constructor(public router: Router, private imageService: ImageHostingService ) {}

    ngOnInit() {
       this.getPosterList();
       let isMobile = false;
       if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
           || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

       if (isMobile) {
         this.minWidth = '';
       }
    }

    changePage(num) {
        if (num >= 0 && num <= this.totalPage) {
            this.page = num;
            this.getPosterList();
        }
    }


    changeRow() {
        this.page = 0;
        this.getPosterList();
    }

    changeSort() {
        this.getPosterList();
    }

    getPosterList() {
      this.imageService.getPosters(this.row, this.page, this.sort, 'sign').subscribe(data => {
        this.numberOfElements = data.numberOfElements;
        this.totalPage = data.totalPages;
        this.totalElement = data.totalElements;
        this.posters = data.content;
        this.pageStart = Math.floor(((this.page) / 10)) * 10 + 1;
        this.pageEnd = (this.pageStart + 9);
        if ( this.pageEnd > this.totalPage) {
            this.pageEnd = this.totalPage;
        }
      });
    }

    posterRemove(imageId: string) {
        if (confirm('삭제하시겠습니까?')) {
            this.imageService.removeImages(imageId)
            .subscribe(response => {
              this.changePage(this.page);
            });
        }
    }

    changeModalSrc(src: string, sinkLink: string) {
      this.modalSrc = src;
      this.signUrl = sinkLink;
    }

    getImageSrc(poster: ImageModel) {
      for (const i in this.posters) {
        if (this.posters[i].imageNo === poster.imageNo) {
          this.modalIndex = i;
          break;
        }
      }
      return poster.link;
    }

    getSinkLink(poster: ImageModel) {
      for (const i in this.posters) {
        if (this.posters[i].imageNo === poster.imageNo) {
          this.modalIndex = i;
          break;
        }
      }
      return poster.sinkLink;
    }


    moveModalImage(num: number) {

      const maxSize: number = this.posters.length - 1;
      const minSize = 0;

      let index: number = Number(this.modalIndex) + num;
      if (index > maxSize) {
        index = 0;
      } else if (index < minSize) {
        index = maxSize;
      }

      this.changeModalSrc(this.getImageSrc(this.posters[index]), this.getSinkLink(this.posters[index]));
    }

    copyLink() {
      alert('복사되었습니다.');
  }

  paginationHandler(event: number) {
    this.page = event;
    this.getPosterList();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/sign/list/sign-list.component.ts